export const defaultCardFieldLengths = {
  securityCodeLength: 3,
  cardNumberLengthRange: '{16}',
};

export const cardOptions = [
  {
    value: 'DEL',
    label: 'Visa Debit',
    fieldLengths: defaultCardFieldLengths,
  },
  {
    value: 'MCD',
    label: 'Mastercard Debit',
    fieldLengths: defaultCardFieldLengths,
  },
  {
    value: 'MAE',
    label: 'Maestro',
    fieldLengths: defaultCardFieldLengths,
  },
  {
    value: 'ELC',
    label: 'Electron',
    fieldLengths: defaultCardFieldLengths,
  },
  {
    value: 'VIS',
    label: 'Visa Credit',
    fieldLengths: defaultCardFieldLengths,
  },
  {
    value: 'MSC',
    label: 'Mastercard Credit',
    fieldLengths: defaultCardFieldLengths,
  },
  {
    value: 'AMX',
    label: 'American Express',
    fieldLengths: {
      securityCodeLength: 4,
      cardNumberLengthRange: '{15}',
    },
  },
];

export const PAYMENT_PLAN_TYPES = {
  PAY_IN_FULL: 'PAY_IN_FULL',
  LOW_DEPOSIT: 'LOW_DEPOSIT',
  STANDARD_DEPOSIT: 'STANDARD_DEPOSIT',
  SPREAD_THE_COST: 'SPREAD_THE_COST',
};



/** WEBPACK FOOTER **
 ** ./src/constants/payment.js
 **/